
import ReactDOM from 'react-dom/client';
import Landing from './components/Landing';
import Dashboard from './components/Dashboard';
import Authenticate from './components/Authenticate';
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import './assets/css/index.css';
import './assets/css/scheme.css';

const router = createBrowserRouter([
    { path: "/", element: <Landing/> },
    { path: "/auth", element: <Authenticate/> },
    { path: "/dashboard", element: <Dashboard/> },
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    //<React.StrictMode>
    <RouterProvider router={router} />
    //</React.StrictMode>
);

